"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeedMap = exports.NeedMapsFieldCategoryResults = exports.NeedMapsCategory = exports.NeedMapsResults = void 0;
const IndividualStats_1 = require("./IndividualStats");
const Raster_1 = require("./Raster");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
class NeedMapsResults {
    constructor(obj) {
        this.stats = new IndividualStats_1.BecropStats(obj.stats || {});
    }
}
exports.NeedMapsResults = NeedMapsResults;
const CROP_PROTECTION = 'crop-protection-needs';
const BIO_STIMULANT = 'bio-stimulant-needs';
const MANAGEMENT = 'management-needs';
const RATE = 'rate';
const colorController = new ColorLibController_1.default();
class NeedMapsCategory {
    constructor(obj) {
        this.slug = obj.slug || '-';
        this.title = obj.title || '-';
        this.caption = obj.caption || '-';
        this.description = obj.description || '-';
        this.enabled = obj.enabled || false;
        this.reverseScale = obj.reverseScale || false;
        this.typeScale = obj.typeScale || 'score';
    }
    mapFullScaleIntoNeedScale(num) {
        if (num < 3)
            return 1;
        if (num < 4 && num >= 3)
            return 3;
        return 5;
    }
    getCuratedRank(raw) {
        const max = 5;
        const min = 1;
        if (!this.reverseScale)
            return this.mapFullScaleIntoNeedScale(raw);
        return this.mapFullScaleIntoNeedScale(max - (raw - min));
    }
    getColorByRank(value, reverse = false) {
        let colorScale = ['#E6D581', '#FF9A51', '#E52721'];
        let fieldFill = '#78757350';
        let roundedValue = Math.round(value);
        if (roundedValue > 0 && roundedValue < 3) {
            fieldFill = reverse ? colorScale[2] : colorScale[0];
        }
        else if (roundedValue < 4 && roundedValue >= 3) {
            fieldFill = reverse ? colorScale[1] : colorScale[1];
        }
        else if (roundedValue >= 4) {
            fieldFill = reverse ? colorScale[0] : colorScale[2];
        }
        return fieldFill;
    }
    getColorByScore(value, reverse = false) {
        let colorScale = ['#E6D581', '#FF9A51', '#E52721'];
        let fieldFill = '#78757350';
        if (value > 0 && value < 40) {
            fieldFill = reverse ? colorScale[2] : colorScale[0];
        }
        else if (value >= 40 && value < 60) {
            fieldFill = reverse ? colorScale[1] : colorScale[1];
        }
        else if (value >= 60) {
            fieldFill = reverse ? colorScale[0] : colorScale[2];
        }
        return fieldFill;
    }
    getFillColor(mean) {
        let colorScale = ['#E6D581', '#FF9A51', '#E52721'];
        let fieldFill = '#78757350';
        switch (this.slug) {
            case CROP_PROTECTION:
                return this.getColorByScore(mean, this.reverseScale);
                return this.getColorByRank(mean, this.reverseScale);
                break;
            case BIO_STIMULANT:
                return this.getColorByScore(mean, this.reverseScale);
                break;
            case MANAGEMENT:
                return this.getColorByScore(mean, this.reverseScale);
                break;
            case RATE:
                return colorController.getCategoryColor(this.title);
            default:
                break;
        }
        return fieldFill;
    }
    getRasterScaleColor() {
        let colorScale = ['#E6D581', '#FF9A51', '#E52721'];
        let fieldFill = '#78757350';
        let color = [
            'interpolate',
            ['linear'],
            ['band', 1],
            0,
            [0, 0, 0, 0],
            0.00001,
            '#E52721',
            0.39999,
            '#E52721',
            0.4,
            '#FF9A51',
            0.59999,
            '#FF9A51',
            0.6,
            '#E6D581',
            0.99999,
            '#E6D581',
            1,
            '#E6D581',
        ];
        if (this.slug === CROP_PROTECTION) {
            color = [
                'interpolate',
                ['linear'],
                ['band', 1],
                0,
                [0, 0, 0, 0],
                0.00001,
                '#E52721',
                0.59999,
                '#E52721',
                0.6,
                '#FF9A51',
                0.79999,
                '#FF9A51',
                0.8,
                '#E6D581',
                1,
                '#E6D581',
            ];
        }
        return color;
    }
    getRasterScaleLimits() {
        return this.slug === CROP_PROTECTION ?
            { min: 0, max: 5 } :
            { min: 0, max: 100 };
    }
}
exports.NeedMapsCategory = NeedMapsCategory;
class NeedMapsFieldCategoryResults {
    constructor(obj) {
        this.field_id = obj.field_id || -1;
        this.category = new NeedMapsCategory(obj.category);
        this.results = new NeedMapsResults(obj.results ||
            {
                stats: {
                    mean: -1,
                    min: -1,
                    max: -1,
                    q_25: -1,
                    q_50: -1,
                    q_75: -1
                }
            });
    }
    get color() {
        return this.category.getFillColor(this.results.stats.mean);
    }
    get transparency() {
        return `${this.category.getFillColor(this.results.stats.mean)}70`;
    }
}
exports.NeedMapsFieldCategoryResults = NeedMapsFieldCategoryResults;
class NeedMap {
    constructor(obj) {
        this.category = new NeedMapsCategory({
            slug: obj.slug,
            title: obj.title,
            caption: obj.caption,
            description: obj.description,
            enabled: obj.enabled,
            reverseScale: obj.reverseScale,
            typeScale: obj.typeScale
        });
        this.results = obj.results ? new Raster_1.RasterItem(obj.results) : new Raster_1.RasterItem({});
    }
}
exports.NeedMap = NeedMap;
